(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fv-product"]) return;
  try {
    
  (function () {
    function initProduct(root) {
      if (root.dataset.fvReady) return;
      root.dataset.fvReady = '1';

      var threshold = parseInt(root.dataset.threshold, 10) || 0;
      var discounts = { 1: 0, 2: parseFloat(root.dataset.d2) || 0, 3: parseFloat(root.dataset.d3) || 0 };
      var formatter;
      try {
        formatter = new Intl.NumberFormat(root.dataset.locale || 'fr', { style: 'currency', currency: root.dataset.currency || 'EUR' });
      } catch (e) {
        formatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
      }
      function money(cents) {
        return formatter.format(cents / 100);
      }
      function all(selector) {
        return Array.prototype.slice.call(root.querySelectorAll(selector));
      }

      var template = root.querySelector('[data-fv-unit-template]');
      var tiers = all('[data-fv-tier]');
      var idInput = root.querySelector('[data-fv-id-input]');
      var qtyInput = root.querySelector('[data-fv-qty-input]');
      var expressEl = root.querySelector('[data-fv-express]');
      var selections = [];

      function optionFor(select) {
        return select.options[select.selectedIndex];
      }

      function activeTier() {
        return tiers.filter(function (tier) { return tier.classList.contains('is-selected'); })[0] || tiers[0];
      }

      function syncOptSelects(unit) {
        var master = unit.querySelector('[data-fv-unit-select]');
        var optSelects = Array.prototype.slice.call(unit.querySelectorAll('[data-fv-opt-select]'));
        if (!master || !optSelects.length) return;
        var current = optionFor(master);
        var variants = Array.prototype.slice.call(master.options);
        optSelects.forEach(function (select) {
          select.value = current.dataset['o' + select.dataset.pos];
        });
        optSelects.forEach(function (select) {
          var pos = parseInt(select.dataset.pos, 10);
          Array.prototype.forEach.call(select.options, function (choice) {
            var possible = variants.some(function (variant) {
              if (variant.disabled || variant.dataset['o' + pos] !== choice.value) return false;
              for (var lower = 1; lower < pos; lower++) {
                if (variant.dataset['o' + lower] !== current.dataset['o' + lower]) return false;
              }
              return true;
            });
            choice.disabled = !possible;
          });
        });
      }

      function pickFromOptions(unit, changed) {
        var master = unit.querySelector('[data-fv-unit-select]');
        var optSelects = Array.prototype.slice.call(unit.querySelectorAll('[data-fv-opt-select]'));
        var variants = Array.prototype.slice.call(master.options).filter(function (variant) { return !variant.disabled; });
        var changedPos = parseInt(changed.dataset.pos, 10);
        var exact = variants.filter(function (variant) {
          return optSelects.every(function (select) { return variant.dataset['o' + select.dataset.pos] === select.value; });
        })[0];
        var fallback = variants.filter(function (variant) {
          for (var pos = 1; pos <= changedPos; pos++) {
            var select = optSelects[pos - 1];
            if (select && variant.dataset['o' + pos] !== select.value) return false;
          }
          return true;
        })[0];
        var chosen = exact || fallback;
        if (!chosen) {
          syncOptSelects(unit);
          return;
        }
        master.value = chosen.value;
        master.dispatchEvent(new Event('change', { bubbles: true }));
      }

      function renderUnits() {
        if (!template) return;
        tiers.forEach(function (tier) {
          var holder = tier.querySelector('[data-fv-units]');
          if (!holder) return;
          holder.innerHTML = '';
          if (!tier.classList.contains('is-selected')) return;
          var qty = parseInt(tier.dataset.fvTier, 10);
          for (var i = 0; i < qty; i++) {
            var unit = template.content.firstElementChild.cloneNode(true);
            var select = unit.querySelector('[data-fv-unit-select]');
            unit.querySelector('[data-fv-unit-n]').textContent = String(i + 1);
            if (!selections[i]) selections[i] = selections[0] || select.value;
            select.value = selections[i];
            select.dataset.index = String(i);
            unit.querySelector('[data-fv-unit-img]').src = optionFor(select).dataset.img;
            holder.appendChild(unit);
            syncOptSelects(unit);
          }
          selections.length = qty;
        });
      }

      function unitOptions() {
        var tier = activeTier();
        if (!tier) return [];
        var selects = Array.prototype.slice.call(tier.querySelectorAll('[data-fv-unit-select]'));
        return selects.map(optionFor);
      }

      function firstOption() {
        var options = unitOptions();
        if (options.length) return options[0];
        if (!template) return null;
        var select = template.content.querySelector('[data-fv-unit-select]');
        return select ? optionFor(select) : null;
      }

      function refresh() {
        var first = firstOption();
        if (!first) return;
        var price = parseInt(first.dataset.price, 10) || 0;
        var ref = parseInt(first.dataset.ref, 10) || 0;
        var showRef = ref > price;

        var mode = first.dataset.refMode || 'observed';
        root.dataset.refMode = mode;
        all('[data-fv-price-info]').forEach(function (button) {
          button.setAttribute('data-fv-modal-open', (mode === 'compare' ? 'fv-modal-prix-ref-' : 'fv-modal-prix-') + root.dataset.sectionId);
        });
        all('[data-fv-price]').forEach(function (el) { el.textContent = money(price); });
        all('[data-fv-price-split]').forEach(function (el) {
          var intEl = el.querySelector('.fv-price__int');
          var decEl = el.querySelector('.fv-price__dec');
          if (!intEl || !decEl) return;
          intEl.textContent = String(Math.floor(price / 100));
          decEl.textContent = ('0' + (price % 100)).slice(-2) + '\u00a0€';
        });
        all('[data-fv-ref-wrap]').forEach(function (el) { el.hidden = !showRef; });
        if (showRef) {
          all('[data-fv-ref]').forEach(function (el) { el.textContent = money(ref); });
          all('[data-fv-percent]').forEach(function (el) { el.textContent = String(Math.round(((ref - price) / ref) * 100)); });
          all('[data-fv-saving]').forEach(function (el) { el.textContent = money(ref - price); });
          var badgeThreshold = parseInt(root.dataset.badgeThreshold, 10) || 0;
          var savedCents = ref - price;
          var badgeText = Math.round((savedCents / ref) * 100) + ' %';
          if (badgeThreshold > 0 && price >= badgeThreshold) {
            badgeText = savedCents % 100 === 0 ? money(savedCents).replace(/[.,]00/, '') : money(savedCents);
          }
          all('[data-fv-badge]').forEach(function (el) { el.textContent = badgeText; });
        }

        var options = unitOptions();
        var activeQty = parseInt(activeTier().dataset.fvTier, 10);
        var activeTotal = price;
        tiers.forEach(function (tier) {
          var qty = parseInt(tier.dataset.fvTier, 10);
          var sum = 0;
          for (var i = 0; i < qty; i++) {
            var option = qty === activeQty && options[i] ? options[i] : first;
            sum += parseInt(option.dataset.price, 10) || 0;
          }
          var total = Math.round(sum * (100 - discounts[qty]) / 100);
          if (qty === activeQty) activeTotal = total;
          var priceEl = tier.querySelector('[data-fv-tier-price]');
          if (priceEl) priceEl.textContent = money(total);
          var unitEl = tier.querySelector('[data-fv-tier-unit]');
          if (unitEl) unitEl.textContent = money(Math.round(total / qty));
          var saveEl = tier.querySelector('[data-fv-tier-save]');
          if (saveEl) saveEl.textContent = money(sum - total);
          var shipEl = tier.querySelector('[data-fv-tier-ship]');
          if (shipEl) shipEl.hidden = !(threshold > 0 && total >= threshold);
        });
        all('[data-fv-total]').forEach(function (el) { el.textContent = money(activeTotal); });

        if (idInput) idInput.value = first.value;
        if (qtyInput) qtyInput.value = String(activeQty);
        if (expressEl) {
          var expressOptions = options.length ? options : [first];
          var mixedUnits = expressOptions.some(function (option) { return option.value !== expressOptions[0].value; });
          var soldOutUnit = expressOptions.some(function (option) { return option.disabled; });
          expressEl.hidden = mixedUnits || soldOutUnit;
        }

        var low = parseInt(first.dataset.low, 10) || 0;
        all('[data-fv-low-stock]').forEach(function (row) {
          row.hidden = !(low > 0);
          var textEl = row.querySelector('[data-fv-low-stock-text]');
          if (textEl && low > 0) textEl.textContent = (row.dataset.text || '').replace('{n}', String(low));
        });
      }

      function syncGallery(option) {
        var mediaId = option && option.dataset.mediaId;
        if (!mediaId) return;
        var slides = all('[data-fv-slide]');
        slides.forEach(function (slide, index) {
          if (slide.dataset.mediaId === mediaId) goTo(index);
        });
      }

      tiers.forEach(function (tier) {
        tier.addEventListener('click', function (event) {
          if (event.target.closest('label, select, button, a, [data-fv-units]')) return;
          var radio = tier.querySelector('.fv-tier__radio');
          if (!radio || radio.checked) return;
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      root.addEventListener('change', function (event) {
        var target = event.target;
        if (target.classList.contains('fv-tier__radio')) {
          var picked = target.closest('[data-fv-tier]');
          var before = picked ? picked.getBoundingClientRect().top : 0;
          tiers.forEach(function (tier) {
            tier.classList.toggle('is-selected', tier.contains(target));
          });
          renderUnits();
          refresh();
          if (picked) {
            var drift = picked.getBoundingClientRect().top - before;
            if (Math.abs(drift) > 1) window.scrollBy({ top: drift, left: 0, behavior: 'instant' });
          }
        }
        if (target.matches('[data-fv-opt-select]')) {
          pickFromOptions(target.closest('[data-fv-unit]'), target);
          return;
        }
        if (target.matches('[data-fv-unit-select]')) {
          var index = parseInt(target.dataset.index, 10) || 0;
          selections[index] = target.value;
          var option = optionFor(target);
          var unitEl = target.closest('[data-fv-unit]');
          var img = unitEl.querySelector('[data-fv-unit-img]');
          if (img) img.src = option.dataset.img;
          syncOptSelects(unitEl);
          if (index === 0) {
            syncGallery(option);
            var url = new URL(window.location.href);
            url.searchParams.set('variant', target.value);
            window.history.replaceState({}, '', url.toString());
          }
          refresh();
        }
      });

      var track = root.querySelector('[data-fv-track]');
      var thumbs = all('[data-fv-thumb]');
      var dots = all('[data-fv-dots] .fv-gallery__dot');
      var slideEls = all('[data-fv-slide]');
      var counterEl = root.querySelector('[data-fv-counter]');
      var activeIndex = 0;
      function slideHeight(index) {
        var slide = slideEls[index];
        if (!slide || !slide.firstElementChild) return 0;
        var image = slide.querySelector('img');
        var w = image ? parseFloat(image.getAttribute('width')) : 0;
        var h = image ? parseFloat(image.getAttribute('height')) : 0;
        if (w && h && image === slide.firstElementChild) return track.clientWidth * h / w;
        return slide.firstElementChild.getBoundingClientRect().height;
      }
      function fitTrack() {
        if (!track) return;
        var horizontal = getComputedStyle(track).flexWrap !== 'wrap' && getComputedStyle(track).flexDirection !== 'column';
        var squareStage = root.dataset.gallery === 'slider' && window.matchMedia('(min-width: 990px)').matches;
        if (!horizontal || !slideEls.length || squareStage) {
          track.style.height = '';
          return;
        }
        var pos = track.scrollLeft / Math.max(track.clientWidth, 1);
        var from = Math.max(0, Math.min(Math.floor(pos + 0.02), slideEls.length - 1));
        var to = Math.max(0, Math.min(Math.ceil(pos - 0.02), slideEls.length - 1));
        var height = Math.max(slideHeight(from), slideHeight(to));
        if (height > 40) track.style.height = Math.ceil(height) + 'px';
        if (track.scrollTop) track.scrollTop = 0;
      }
      function setActive(index) {
        activeIndex = Math.max(0, Math.min(index, slideEls.length - 1));
        thumbs.forEach(function (thumb, i) {
          var on = i === activeIndex;
          thumb.classList.toggle('is-active', on);
          if (on && thumb.parentElement && thumb.parentElement.scrollWidth > thumb.parentElement.clientWidth) {
            thumb.parentElement.scrollTo({ left: thumb.offsetLeft - thumb.parentElement.clientWidth / 2 + thumb.clientWidth / 2, behavior: 'smooth' });
          }
        });
        dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === Math.min(activeIndex, dots.length - 1)); });
        if (counterEl) counterEl.textContent = String(activeIndex + 1);
        fitTrack();
      }
      window.addEventListener('resize', fitTrack, { passive: true });
      window.addEventListener('load', fitTrack);
      window.addEventListener('pageshow', fitTrack);
      window.addEventListener('orientationchange', function () { window.setTimeout(fitTrack, 250); });
      slideEls.forEach(function (slide) {
        var image = slide.querySelector('img');
        if (image && !image.complete) image.addEventListener('load', fitTrack, { once: true });
      });
      fitTrack();
      function goTo(index) {
        if (!track) return;
        track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
        setActive(index);
      }
      if (track) {
        var ticking = false;
        var settleTimer = 0;
        track.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            var next = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
            if (next !== activeIndex) setActive(next);
            else fitTrack();
            ticking = false;
          });
          window.clearTimeout(settleTimer);
          settleTimer = window.setTimeout(fitTrack, 160);
        }, { passive: true });
        if ('ResizeObserver' in window) new ResizeObserver(fitTrack).observe(track);
      }
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () { goTo(parseInt(thumb.dataset.fvThumb, 10) || 0); });
      });

      var thumbWrap = root.querySelector('[data-fv-thumbwrap]');
      var thumbStrip = root.querySelector('[data-fv-thumbs]');
      function syncThumbNav() {
        if (!thumbWrap || !thumbStrip) return;
        var overflow = thumbStrip.scrollWidth > thumbStrip.clientWidth + 2;
        thumbWrap.classList.toggle('has-overflow', overflow);
        var navs = thumbWrap.querySelectorAll('[data-fv-thumbs-arrow]');
        if (navs[0]) navs[0].disabled = thumbStrip.scrollLeft < 2;
        if (navs[1]) navs[1].disabled = thumbStrip.scrollLeft + thumbStrip.clientWidth > thumbStrip.scrollWidth - 2;
      }
      if (thumbWrap && thumbStrip) {
        thumbWrap.addEventListener('click', function (event) {
          var nav = event.target.closest('[data-fv-thumbs-arrow]');
          if (!nav) return;
          thumbStrip.scrollBy({ left: parseInt(nav.dataset.fvThumbsArrow, 10) * thumbStrip.clientWidth * 0.8, behavior: 'smooth' });
        });
        thumbStrip.addEventListener('scroll', syncThumbNav, { passive: true });
        window.addEventListener('resize', syncThumbNav, { passive: true });
        window.addEventListener('load', syncThumbNav);
        syncThumbNav();
      }

      var zoomDialog = root.querySelector('[data-fv-zoom-dialog]');
      var zoomHolder = root.querySelector('[data-fv-zoom-holder]');
      var zoomCount = root.querySelector('[data-fv-zoom-count]');
      var zoomImages = all('[data-fv-zoom]');
      var zoomIndex = 0;
      function showZoom(index) {
        if (!zoomImages.length) return;
        zoomIndex = (index + zoomImages.length) % zoomImages.length;
        var source = zoomImages[zoomIndex];
        var large = document.createElement('img');
        large.src = source.currentSrc || source.src;
        large.alt = source.alt || '';
        var fullSrc = source.getAttribute('data-fv-zoom');
        if (fullSrc && fullSrc !== 'true') {
          var loader = new Image();
          loader.onload = function () {
            if (large.isConnected) large.src = fullSrc;
          };
          loader.src = fullSrc;
        }
        large.className = 'fv-zoom__img';
        zoomHolder.classList.remove('is-zoomed');
        zoomHolder.innerHTML = '';
        zoomHolder.appendChild(large);
        if (zoomCount) zoomCount.textContent = (zoomIndex + 1) + ' / ' + zoomImages.length;
        zoomDialog.classList.toggle('fv-zoom--single', zoomImages.length < 2);
      }
      root.addEventListener('click', function (event) {
        var arrow = event.target.closest('[data-fv-arrow]');
        if (arrow) {
          var count = slideEls.length;
          goTo((activeIndex + parseInt(arrow.dataset.fvArrow, 10) + count) % count);
          return;
        }
        var step = event.target.closest('[data-fv-zoom-step]');
        if (step) {
          showZoom(zoomIndex + parseInt(step.dataset.fvZoomStep, 10));
          return;
        }
        if (event.target.classList.contains('fv-zoom__img')) {
          var zoomed = zoomHolder.classList.toggle('is-zoomed');
          if (zoomed) {
            var box = zoomHolder.getBoundingClientRect();
            var ratioX = (event.clientX - box.left) / box.width;
            var ratioY = (event.clientY - box.top) / box.height;
            window.requestAnimationFrame(function () {
              zoomHolder.scrollLeft = (zoomHolder.scrollWidth - zoomHolder.clientWidth) * ratioX;
              zoomHolder.scrollTop = (zoomHolder.scrollHeight - zoomHolder.clientHeight) * ratioY;
            });
          }
          return;
        }
        if (root.dataset.zoom !== 'true') return;
        var image = event.target.closest('[data-fv-zoom]');
        if (!image || !zoomDialog || !zoomHolder || !zoomDialog.showModal) return;
        showZoom(zoomImages.indexOf(image));
        zoomDialog.showModal();
      });
      if (zoomDialog) {
        zoomDialog.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') showZoom(zoomIndex - 1);
          if (event.key === 'ArrowRight') showZoom(zoomIndex + 1);
        });
        var touchStartX = null;
        zoomDialog.addEventListener('touchstart', function (event) {
          touchStartX = zoomHolder.classList.contains('is-zoomed') ? null : event.touches[0].clientX;
        }, { passive: true });
        zoomDialog.addEventListener('touchend', function (event) {
          if (touchStartX === null) return;
          var delta = event.changedTouches[0].clientX - touchStartX;
          if (Math.abs(delta) > 50) showZoom(zoomIndex + (delta < 0 ? 1 : -1));
          touchStartX = null;
        });
      }

      function collectItems() {
        var options = unitOptions();
        var qty = parseInt(activeTier().dataset.fvTier, 10) || 1;
        var counts = {};
        if (options.length) {
          options.forEach(function (option) { counts[option.value] = (counts[option.value] || 0) + 1; });
        } else if (idInput) {
          counts[idInput.value] = qty;
        }
        return Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
      }

      function showError(message) {
        all('[data-fv-error]').forEach(function (el, index) {
          el.textContent = message || '';
          el.hidden = !message || index > 0;
        });
      }

      function prepareCheckout(items) {
        var productId = parseInt(root.dataset.productId, 10);
        return fetch(root.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then(function (response) { return response.ok ? response.json() : null; })
          .then(function (cart) {
            if (!cart || !cart.items) return false;
            var lines = cart.items.filter(function (item) { return item.product_id === productId; });
            if (!lines.length) return false;
            var inCart = {};
            lines.forEach(function (item) { inCart[item.variant_id] = (inCart[item.variant_id] || 0) + item.quantity; });
            var same = Object.keys(inCart).length === items.length && items.every(function (item) { return inCart[item.id] === item.quantity; });
            if (same) return true;
            var updates = {};
            lines.forEach(function (item) { updates[item.key] = 0; });
            return fetch(root.dataset.updateUrl + '.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates: updates })
            }).then(function () { return false; });
          })
          .catch(function () { return false; });
      }

      var busy = false;
      function addToCart() {
        if (busy) return;
        busy = true;
        showError('');
        var buttons = all('[data-fv-atc]');
        buttons.forEach(function (button) { button.setAttribute('aria-busy', 'true'); button.disabled = true; });
        var drawer = document.querySelector('cart-drawer');
        var goCheckout = root.dataset.afterAdd === 'checkout';
        var useDrawer = !goCheckout && root.dataset.afterAdd === 'drawer' && drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function';
        var payload = { items: collectItems() };
        if (useDrawer) {
          payload.sections = drawer.getSectionsToRender().map(function (section) { return section.id; });
          payload.sections_url = window.location.pathname;
        }
        (goCheckout ? prepareCheckout(payload.items) : Promise.resolve(false))
          .then(function (alreadyInCart) {
            if (alreadyInCart) return { ok: true, data: {} };
            return fetch(root.dataset.addUrl + '.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(payload)
            }).then(function (response) {
              return response.json().then(function (data) { return { ok: response.ok, data: data }; });
            });
          })
          .then(function (result) {
            if (!result.ok) throw new Error(result.data.description || result.data.message || 'Erreur');
            if (goCheckout) {
              window.location.href = root.dataset.checkoutUrl || '/checkout';
              return;
            }
            if (useDrawer && result.data.sections) {
              try {
                drawer.classList.remove('is-empty');
                drawer.renderContents(result.data);
                busy = false;
                buttons.forEach(function (button) { button.removeAttribute('aria-busy'); button.disabled = false; });
                return;
              } catch (drawerError) {
                window.location.href = root.dataset.cartUrl;
                return;
              }
            }
            window.location.href = root.dataset.cartUrl;
          })
          .catch(function (error) {
            busy = false;
            buttons.forEach(function (button) { button.removeAttribute('aria-busy'); button.disabled = false; });
            showError(error.message);
            var anchor = root.querySelector('[data-fv-buy-anchor]');
            if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
      }

      window.addEventListener('pageshow', function (event) {
        if (!event.persisted) return;
        busy = false;
        all('[data-fv-atc][aria-busy]').forEach(function (button) { button.removeAttribute('aria-busy'); button.disabled = false; });
      });

      var form = root.querySelector('[data-fv-form]');
      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          addToCart();
        });
      }
      root.addEventListener('click', function (event) {
        var button = event.target.closest('[data-fv-atc]');
        if (!button || button.type === 'submit') return;
        event.preventDefault();
        addToCart();
      });

      var anchor = root.querySelector('[data-fv-buy-anchor]');
      var stickies = all('[data-fv-sticky]');
      if (anchor && stickies.length) {
        var stickyState = null;
        var updateSticky = function () {
          var box = anchor.getBoundingClientRect();
          var past = box.bottom < 0;
          if (window.innerWidth < 750 && box.top > window.innerHeight) past = true;
          if (past === stickyState) return;
          stickyState = past;
          stickies.forEach(function (sticky) {
            sticky.classList.toggle('is-visible', past);
            sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
            Array.prototype.forEach.call(sticky.querySelectorAll('button'), function (button) {
              button.tabIndex = past ? 0 : -1;
            });
          });
        };
        window.addEventListener('scroll', updateSticky, { passive: true });
        window.addEventListener('resize', updateSticky, { passive: true });
        updateSticky();
      }

      all('[data-fv-description-toggle]').forEach(function (button) {
        var wrapper = button.closest('[data-fv-description]');
        var body = wrapper.querySelector('[data-fv-description-body]');
        if (body.scrollHeight <= 460) wrapper.classList.add('is-short');
        button.addEventListener('click', function () {
          var open = wrapper.classList.toggle('is-open');
          button.setAttribute('aria-expanded', open ? 'true' : 'false');
          button.textContent = open ? button.dataset.less : button.dataset.more;
          if (!open) wrapper.scrollIntoView({ block: 'start', behavior: 'smooth' });
        });
      });

      if (window.innerWidth < 750) {
        all('[data-fv-fold]').forEach(function (fold) { fold.removeAttribute('open'); });
      }

      var dispatchRows = all('[data-fv-dispatch]');
      function parisNow() {
        try {
          return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Paris' }));
        } catch (e) {
          return new Date();
        }
      }
      function updateDispatch() {
        var now = parisNow();
        var day = now.getDay();
        var dayNames = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
        dispatchRows.forEach(function (row) {
          var cutoff = parseInt(row.dataset.cutoff, 10);
          if (isNaN(cutoff)) cutoff = 16;
          var textEl = row.querySelector('[data-fv-dispatch-text]');
          var open = day >= 1 && day <= 5 && now.getHours() < cutoff;
          var text;
          if (open) {
            var minutes = (cutoff - now.getHours()) * 60 - now.getMinutes();
            var hoursLeft = Math.floor(minutes / 60);
            var minutesLeft = minutes % 60;
            var label = hoursLeft > 0 ? hoursLeft + ' h ' + ('0' + minutesLeft).slice(-2) + ' min' : minutesLeft + ' min';
            text = (row.dataset.before || '').replace('{temps}', label);
          } else {
            var next = new Date(now.getTime());
            var steps = 0;
            do {
              next.setDate(next.getDate() + 1);
              steps++;
            } while (next.getDay() === 0 || next.getDay() === 6);
            var when = next.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'short' });
            if (!when) when = dayNames[next.getDay()];
            text = (row.dataset.after || '').replace('{jour}', when);
          }
          if (textEl) textEl.textContent = text;
          row.hidden = !text;
        });
      }
      if (dispatchRows.length) {
        updateDispatch();
        window.setInterval(updateDispatch, 30000);
      }

      var offerRows = all('[data-fv-offer-end]');
      function updateOffers() {
        var now = parisNow().getTime();
        offerRows.forEach(function (row) {
          var parts = (row.dataset.fvOfferEnd || '').match(/(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
          if (!parts) {
            row.hidden = true;
            return;
          }
          var end = new Date(+parts[1], +parts[2] - 1, +parts[3], +(parts[4] || 23), +(parts[5] || 59), 59).getTime();
          var left = Math.floor((end - now) / 1000);
          if (left <= 0) {
            row.hidden = true;
            return;
          }
          var days = Math.floor(left / 86400);
          var hours = Math.floor((left % 86400) / 3600);
          var minutes = Math.floor((left % 3600) / 60);
          var seconds = left % 60;
          var two = function (value) { return ('0' + value).slice(-2); };
          var label = (days > 0 ? days + ' j ' : '') + two(hours) + ' h ' + two(minutes) + ' min ' + two(seconds) + ' s';
          var textEl = row.querySelector('[data-fv-offer-text]');
          if (textEl) {
            var pieces = (row.dataset.text || '{temps}').split('{temps}');
            textEl.textContent = '';
            textEl.appendChild(document.createTextNode(pieces[0] || ''));
            var strong = document.createElement('strong');
            strong.textContent = label;
            textEl.appendChild(strong);
            textEl.appendChild(document.createTextNode(pieces[1] || ''));
          }
          row.hidden = false;
        });
      }
      if (offerRows.length) {
        updateOffers();
        window.setInterval(updateOffers, 1000);
      }

      var minDays = parseInt(root.dataset.minDays, 10);
      var maxDays = parseInt(root.dataset.maxDays, 10);
      var businessDays = root.dataset.businessDays === 'true';
      function dateIn(days) {
        var date = new Date();
        if (businessDays) {
          var left = days;
          while (left > 0) {
            date.setDate(date.getDate() + 1);
            if (date.getDay() !== 0 && date.getDay() !== 6) left--;
          }
        } else {
          date.setDate(date.getDate() + days);
        }
        return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
      }
      if (!isNaN(minDays) && !isNaN(maxDays)) {
        all('[data-fv-date-min]').forEach(function (el) { el.textContent = dateIn(minDays); });
        all('[data-fv-date-max]').forEach(function (el) { el.textContent = dateIn(maxDays); });
      }

      var columns = [root.querySelector('.fv-gallery'), root.querySelector('.fv-info')].filter(Boolean);
      var offset = parseInt(getComputedStyle(root).getPropertyValue('--fv-sticky-top'), 10) || 90;
      function updateColumns() {
        columns.forEach(function (column) {
          var room = window.innerHeight - column.offsetHeight - 24;
          column.style.setProperty('--fv-col-top', Math.min(offset, room) + 'px');
        });
      }
      updateColumns();
      window.addEventListener('resize', updateColumns, { passive: true });
      window.addEventListener('load', updateColumns);
      if ('ResizeObserver' in window) {
        var columnObserver = new ResizeObserver(updateColumns);
        columns.forEach(function (column) { columnObserver.observe(column); });
      }

      tiers.forEach(function (tier) {
        var radio = tier.querySelector('.fv-tier__radio');
        tier.classList.toggle('is-selected', !!(radio && radio.checked));
      });
      renderUnits();
      refresh();
    }

    function initAll() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-fv-product]'), initProduct);
    }

    if (!window.fvModalsBound) {
      window.fvModalsBound = true;
      document.addEventListener('click', function (event) {
        var opener = event.target.closest('[data-fv-modal-open]');
        if (opener) {
          var dialog = document.getElementById(opener.getAttribute('data-fv-modal-open'));
          if (dialog && dialog.showModal) {
            event.preventDefault();
            dialog.showModal();
          }
          return;
        }
        var closer = event.target.closest('[data-fv-modal-close]');
        if (closer) {
          var parent = closer.closest('dialog');
          if (parent) parent.close();
          return;
        }
        if (event.target.tagName === 'DIALOG' && (event.target.classList.contains('fv-modal') || event.target.classList.contains('fv-zoom'))) {
          event.target.close();
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
